var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('setting-content',{attrs:{"title":"Terms And Conditions","settingKey":"termsAndConditionsContent","lang":_vm.language}})}
var staticRenderFns = []

export { render, staticRenderFns }